import { apiRequest } from './auth';

export const projectsAPI = {
  getAll: async () => {
    return await apiRequest('/projects');
  },

  create: async (name) => {
    return await apiRequest('/projects', {
      method: 'POST',
      body: JSON.stringify({ name }),
    });
  },

  delete: async (name) => {
    return await apiRequest(`/projects/${encodeURIComponent(name)}`, {
      method: 'DELETE',
    });
  }
};

export default projectsAPI;
